import { type ReactElement } from 'react';
import FeaturePageLayout from '../../components/features/FeaturePageLayout';

export default function Rechnungen(): ReactElement {
  return (
    <FeaturePageLayout
      badge="Buchhaltung"
      title="Professionelle Rechnungen in Sekunden erstellen"
      subtitle="Rechnungen nach § 14 UStG mit eigenem Nummernkreis, Vorlagen und Versand per E-Mail – als PDF oder E-Rechnung (ZUGFeRD/XRechnung)."
      heroImage="/screenshots/hero-rechnung-erstellen.webp"
      heroImageAlt="Saldify Rechnungseditor: Empfänger, Positionen, Rabatt und USt mit automatischer Summenberechnung"
      features={[
        {
          title: 'Rechtskonforme Rechnungen',
          description: 'Alle Pflichtangaben werden automatisch eingefügt. GoBD-konform und revisionssicher.',
        },
        {
          title: 'Individuelle Vorlagen',
          description: 'Gestalten Sie Rechnungen mit Ihrem Logo und Corporate Design. Unbegrenzte Vorlagen im Professional-Tarif.',
        },
        {
          title: 'Automatische Nummerierung',
          description: 'Fortlaufende Rechnungsnummern werden automatisch vergeben. Keine Lücken, keine Duplikate.',
        },
        {
          title: 'Direkter E-Mail-Versand',
          description: 'Versenden Sie Rechnungen mit einem Klick direkt aus Saldify. Inkl. Lesebestätigung.',
        },
        {
          title: 'Wiederkehrende Rechnungen',
          description: 'Automatisieren Sie regelmäßige Abrechnungen. Perfekt für Abonnements und Wartungsverträge.',
        },
        {
          title: 'Mehrere Währungen',
          description: 'Erstellen Sie Rechnungen in Euro, CHF, USD und weiteren Währungen für internationale Kunden.',
        },
      ]}
      sections={[
        {
          title: 'Rechnungen erstellen leicht gemacht',
          description: 'Der intuitive Rechnungseditor führt Sie Schritt für Schritt durch den Prozess. Wählen Sie einen Kunden aus, fügen Sie Positionen hinzu und versenden Sie die Rechnung – alles in weniger als einer Minute.',
          image: '/screenshots/hero-rechnung-erstellen.webp',
          imageAlt: 'Rechnungsformular mit Kundensuche, Positionen und Live-Summe',
          bullets: [
            'Kunden aus dem Adressbuch auswählen',
            'Positionen aus dem Produktkatalog einfügen',
            'Rabatte und Skonto flexibel hinzufügen',
            'Vorschau vor dem Versand',
          ],
          imageSide: 'right',
        },
        {
          title: 'Behalten Sie den Überblick',
          description: 'Im Rechnungs-Dashboard sehen Sie auf einen Blick alle offenen, bezahlten und überfälligen Rechnungen. Filtern und sortieren Sie nach Kunde, Datum oder Betrag.',
          bullets: [
            'Status-Übersicht: Offen, Bezahlt, Überfällig',
            'Schnelle Suche und Filter',
            'Export für Ihren Steuerberater',
            'Zahlungseingänge automatisch zuordnen',
          ],
          imageSide: 'left',
        },
        {
          title: 'Automatisches Mahnwesen',
          description: 'Vergessen Sie nie wieder eine Zahlungserinnerung. Saldify erinnert Sie an überfällige Rechnungen und erstellt Mahnungen automatisch nach Ihren Vorgaben.',
          image: '/screenshots/auto-mahnwesen.webp',
          imageAlt: 'Mahnwesen-Übersicht mit überfälliger Rechnung und Button für die nächste Mahnstufe',
          bullets: [
            'Automatische Zahlungserinnerungen',
            'Mehrstufiges Mahnwesen (1., 2., 3. Mahnung)',
            'Individuelle Mahngebühren',
            'Mahnhistorie pro Kunde',
          ],
          imageSide: 'right',
        },
      ]}
      ctaTitle="Erstellen Sie Ihre erste Rechnung"
      ctaDescription="Starten Sie jetzt und erstellen Sie in wenigen Minuten Ihre erste professionelle Rechnung."
    />
  );
}
